import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import StatsStrip from '../components/common/StatsStrip';
import Testimonial from '../components/common/Testimonial';

const PercheGDPage = () => {
  return (
    <Layout>
      <section className="hero hero--dark" style={{ minHeight: '80vh', display: 'flex', alignItems: 'center' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <h1 className="text-hero" style={{ fontSize: 'clamp(2.5rem, 6vw, 5rem)', lineHeight: 1.1, maxWidth: 900, marginInline: 'auto' }}>
            Perché scegliere i<br /><span style={{ color: 'var(--color-primary)' }}>Giovani Democratici</span>
          </h1>
          <p className="text-lead mt-6 mb-8" style={{ color: 'rgba(255,253,249,0.7)', maxWidth: 600, marginInline: 'auto' }}>La più grande organizzazione politica giovanile d'Italia. In ogni regione, in ogni città.</p>
          <div className="btn-group" style={{ justifyContent: 'center' }}>
            <Link to="/partecipa" className="btn btn--primary btn--lg">Partecipa ora</Link>
            <Link to="/chi-siamo" className="btn btn--outline btn--lg" style={{ color: '#fff', borderColor: 'rgba(255,255,255,0.4)' }}>Scopri chi siamo</Link>
          </div>
        </div>
      </section>

      <section className="section"><div className="container">
        <StatsStrip stats={[{ number: '25.000', label: 'Iscritti' }, { number: '850', label: 'Circoli' }, { number: '107', label: 'Federazioni' }, { number: '20', label: 'Regioni' }]} />
      </div></section>

      <section className="section bg-subtle"><div className="container" style={{ maxWidth: 800, textAlign: 'center' }}>
        <h2 className="h2 mb-10">Perché unirsi a noi?</h2>
        <div className="grid grid-2" style={{ gap: 'var(--space-8)', textAlign: 'left' }}>
          {[
            { icon: '🗳️', title: 'Fai politica vera', text: 'Non delegare ad altri il tuo futuro. Partecipa alle decisioni che contano.' },
            { icon: '📚', title: 'Formati', text: 'Scuola quadri, seminari, laboratori. Cresci come persona e come cittadino.' },
            { icon: '🤝', title: 'Fai rete', text: 'Incontra migliaia di coetanei in tutta Italia, con i tuoi stessi valori.' },
            { icon: '🌍', title: 'Cambia il mondo', text: 'Dalle campagne nazionali al volontariato locale. Ogni azione conta.' },
          ].map((r) => (
            <div key={r.title} style={{ display: 'flex', gap: 'var(--space-4)', alignItems: 'flex-start' }}>
              <div style={{ fontSize: '2rem', flexShrink: 0 }}>{r.icon}</div>
              <div><h3 className="h4 mb-2">{r.title}</h3><p className="text-body-sm text-secondary">{r.text}</p></div>
            </div>
          ))}
        </div>
      </div></section>

      <section className="section"><div className="container">
        <h2 className="h2 text-center mb-10">Cosa dicono di noi</h2>
        <div className="grid grid-3">
          <Testimonial quote="I GD mi hanno dato gli strumenti per capire la politica e farne parte attivamente." name="Sara, 22 anni" role="Circolo GD Navigli, Milano" avatarColor="#e27314" />
          <Testimonial quote="Ho trovato una comunità di persone con cui condividere valori e costruire qualcosa di concreto." name="Marco, 25 anni" role="Segretario di Circolo, Torino" avatarColor="#7a1f1c" />
          <Testimonial quote="Grazie alla scuola di formazione ho capito che la politica può essere fatta bene, con passione e competenza." name="Elena, 20 anni" role="Circolo GD San Frediano, Firenze" avatarColor="#c94f7c" />
        </div>
      </div></section>

      <section className="section"><div className="container" style={{ textAlign: 'center' }}>
        <div className="cta-section">
          <h2 className="h2 mb-4" style={{ color: '#fff' }}>Pronto a fare la tua parte?</h2>
          <p className="mb-8" style={{ color: 'rgba(255,253,249,0.8)', maxWidth: 480, marginInline: 'auto' }}>Unisciti a migliaia di giovani che ogni giorno costruiscono un'Italia migliore.</p>
          <div className="btn-group" style={{ justifyContent: 'center' }}><Link to="/partecipa" className="btn btn--white btn--lg">Partecipa ora</Link><Link to="/circoli" className="btn btn--outline btn--lg" style={{ color: '#fff', borderColor: 'rgba(255,255,255,0.4)' }}>Trova un circolo</Link></div>
        </div>
      </div></section>
    </Layout>
  );
};

export default PercheGDPage;
